// extracted by mini-css-extract-plugin
export default {"container":"mySubscriptions_container__iwSzv","loader":"mySubscriptions_loader__WtO31","error":"mySubscriptions_error__yJF9g"};